import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-not-found',
  standalone: true,
  templateUrl: './page-not-found.component.html',
  imports: [CommonModule],
  styleUrls: ['./page-not-found.component.css']
})
export class PageNotFoundComponent implements OnInit {
 
  pageComponentName = 'PageNotFound';
  constructor() { }

  ngOnInit(): void {
  }

}
